import { Plugin } from 'vue'
// @ts-ignore
import { mitt } from './_globalBus'

/* entity */
import { AvailabilityResponseEntity, SoftSearchAvailabilityResponse } from '@workspace/sab-core/domain/interface/repository/availability'
import { AvailabilityPayload } from '@workspace/sab-core/domain/model/hotel'
import { MapBounds } from '@workspace/sab-core/domain/model/map'
import { Hits } from '@workspace/sab-core/domain/interface/repository/search'


export interface GlobalBusEvents {
  'hotels-change': number[] // todo rename
  'is-filtering': boolean
  'avail-on-load': boolean // special flag when entering with url data. Show loading animation until whole process is done (load content, filter, request avail)
  'reset-hotels': unknown
  'no-filter-results': boolean
  'no-availability': boolean
  'set-availability': AvailabilityResponseEntity[]
  'update-hotel-min-price': { minPrice: number, hotelId: number }
  'availability-payload-change': AvailabilityPayload
  'api-error': boolean
  'soft-search-active': boolean
  'set-soft-search-availability': SoftSearchAvailabilityResponse[]
  'search-query-changed': string
  'active-filter-changed': string
  'map-active': boolean
  'geo-location-data-change': MapBounds | null
  'reset-map': void
  'search-result-changed': Hits[] | undefined
  'reset-promocode': void
  'initial-elasticsearch-request': Hits[] | undefined
  'set-non-br-ibe-hotels': number[]
  'hotel-teaser-hover': { crsPropertyId: number, enableAnimation: boolean }
  'bounce-hotel-map-marker': { crsPropertyId: number, enableAnimation: boolean }
  'map-marker-selected': number
  'external-booking-link-only': boolean
  [x: string | symbol]: unknown
}

export type GlobalBus = import('mitt').Emitter<GlobalBusEvents>

export const bus: GlobalBus = mitt<GlobalBusEvents>()

export default {
  install (app) {
    app.config.globalProperties.$bus = bus
  }
} as Plugin
